import * as authScreenNames from '../../consts/auth/authScreenNames';
import {logoutClearData} from '../../state/ducks/global';
import {dispatch} from '../../state/store';
import pushNotificationService from '../push/pushNotificationService';
import storageService from '../storage/storageService';
import appRouterService from './appRouterService';

const initializeUserSessionActions = () => {};

const initializeStartActions = () => {};

const onAppInit = () => {};

const getAppBaseUrl = () => {};

let logoutInFlight = null;

const clearSession = () => {
    const rememberMe = storageService.getRememberMeFromStorage();

    if (rememberMe) {
        storageService.removeAccessTokenFromStorage();
        storageService.removeAccessTokenExpirationFromStorage();
        storageService.removeRefreshTokenFromStorage();
        storageService.removeDemoViewFromStorage();
    } else {
        storageService.clearLocalStorage();
    }

    dispatch(logoutClearData());

    appRouterService.forwardToAuthPage(authScreenNames.LOGIN);
};

const logout = () => {
    if (!logoutInFlight) {
        logoutInFlight = (async () => {
            try {
                await pushNotificationService.cleanupForLogout();
            } catch (_) {
                // Logout must still complete if Push APIs or cleanup fail.
            } finally {
                clearSession();
            }
        })().finally(() => {
            logoutInFlight = null;
        });
    }
    return logoutInFlight;
};

export default {
    logout,
    getAppBaseUrl,
    initializeStartActions,
    onAppInit,
    initializeUserSessionActions,
};
